import { render, staticRenderFns } from "./ResultRound.vue?vue&type=template&id=972cbe1e&scoped=true"
import script from "./ResultRound.vue?vue&type=script&lang=js"
export * from "./ResultRound.vue?vue&type=script&lang=js"
import style0 from "./ResultRound.vue?vue&type=style&index=0&id=972cbe1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972cbe1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972cbe1e')) {
      api.createRecord('972cbe1e', component.options)
    } else {
      api.reload('972cbe1e', component.options)
    }
    module.hot.accept("./ResultRound.vue?vue&type=template&id=972cbe1e&scoped=true", function () {
      api.rerender('972cbe1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResultRound.vue"
export default component.exports